import { DefaultState, DropdownItem } from 'store/types';
import { Filters } from 'store/types';

export const GET_LODGINGS_NAMES_FOR_FILTER_REQUEST = 'GET_LODGING_NAMES_FOR_FILTER_REQUEST';
export const GET_LODGINGS_NAMES_FOR_FILTER_SUCCESS = 'GET_LODGING_NAMES_FOR_FILTER_SUCCESS';
export const GET_LODGINGS_NAMES_FOR_FILTER_FAILURE = 'GET_LODGING_NAMES_FOR_FILTER_FAILURE';

export interface GetLodgingsNamesForFilterParams {
  filters: Filters;
  paging: {
    page: number;
    pageSize: number;
  };
};

export interface GetLodgingsNamesForFilterData {
  rows: DropdownItem[];
  totalCount: number;
}

export type GetLodgingsNamesForFilterState = DefaultState & {
  contents?: GetLodgingsNamesForFilterData;
};

interface ReadGetLodgingsNamesForFilterRequest {
  type: typeof GET_LODGINGS_NAMES_FOR_FILTER_REQUEST;
};

interface ReadGetLodgingsNamesForFilterSuccess {
  type: typeof GET_LODGINGS_NAMES_FOR_FILTER_SUCCESS,
  contents: GetLodgingsNamesForFilterData;
}

interface ReadGetLodgingsNamesForFilterFailure {
  type: typeof GET_LODGINGS_NAMES_FOR_FILTER_FAILURE;
}

export type GetLodgingsNamesForFilterActionTypes = ReadGetLodgingsNamesForFilterRequest | ReadGetLodgingsNamesForFilterSuccess | ReadGetLodgingsNamesForFilterFailure;
